import React, { useEffect, useState } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { makeAPICall } from './services/apiService';
import './protectedRoute.scss';

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const token = getCookie('oem_auth_token');
  const [eligibiity, setEligibility] = useState(null);
  const history = useHistory();

  useEffect(() => {
    if (window.location.pathname != '/' && window.location.pathname != '/booking-list')
      getAllEligibilityIngressForBc()
  }, [])


  const getAllEligibilityIngressForBc = async () => {
    let config = {
      method: "get",
      url: `/api/loan/checkEligibility`,
    };

    try {
      const response = await makeAPICall(config)
      setEligibility(response?.data);
    } catch (e) {
      console.log("ERR API", e?.response?.data);
    }

  };

  const getComponent = (props) => {
    const envConst = localStorage.getItem('env_const') && JSON.parse(localStorage.getItem('env_const'));

    if ((window?.location?.pathname == '/offline-finance-search' && eligibiity?.isEligibleOfflineFinancing == false) ||
      (window?.location?.pathname == '/manage-orders' && eligibiity?.isEligiblePos == false) ||
      (window?.location?.pathname == '/apply-coupon-search' && eligibiity?.isEligibleOrderDiscount == false) ||
      (window?.location?.href?.includes('offinepayment=true') && eligibiity?.isEligibleOfflinePayment == false) ||
      (window?.location?.pathname == '/search-exchange' && eligibiity?.isEligibleExchange == false) ||
      (window?.location?.pathname == '/check-scooter-eligibility' && envConst?.showSDC == 'false')) {
      return <div className='protected-cont'>
        <div className='protected-title'>Not Authorized</div>
        <div className='protected-home' onClick={() => history.push('/')}>Go to Home</div>
      </div>
    } else
      return <Component {...props} />;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? (
          getComponent(props)
        ) : (
         (() => {
          const redirectUrl =
            props.location.pathname + props.location.search;

          sessionStorage.setItem("postLoginRedirect", redirectUrl);

          return (
            <Redirect
              to={{
                pathname: "/phoneNumber",
              }}
            />
          );
        })()
        )
      }
    />
  );
};
